import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const PaymentCancel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  // Set document title
  useDocumentTitle(t('paymentCancel.title'));

  // Start countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/billing');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoToBilling = () => {
    navigate('/billing');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
          {/* Error Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
              <X className="w-12 h-12 text-red-600" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {t('paymentCancel.cancelTitle')}
          </h1>

          {/* Support Message */}
          <p className="text-lg text-gray-600 mb-8">
            {t('paymentCancel.supportMessage')}
          </p>

          {/* Redirect Message */}
          <div className="bg-gray-50 rounded-xl p-6 mb-8">
            <p className="text-gray-700">
              <Trans
                i18nKey="paymentCancel.redirectMessage"
                values={{ countdown }}
                components={{
                  1: <strong className="font-semibold text-red-600" />
                }}
              />
            </p>
          </div>

          {/* Go to Billing Button */}
          <button
            onClick={handleGoToBilling}
            className="inline-flex items-center px-8 py-3 bg-primary-600 text-white font-semibold rounded-xl hover:bg-primary-700 transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            {t('paymentCancel.goToBilling')}
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel; 